import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CategoriesService } from 'src/app/services/categori.service';

@Component({
  standalone: false,
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css'],
})
export class UserDetailsComponent implements OnInit {
  userId: any;
  user: any = {};
  editForm: FormGroup | any;
  resetPasswordForm: FormGroup | any;
  showDeleteConfirm = false;

  get isSuperAdmin(): boolean {
    return localStorage.getItem('is_super_admin') === 'true';
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rest: CategoriesService
  ) {}

  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('id');
    this.editForm = new FormGroup({
      name: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      username: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(15)]),
      is_admin: new FormControl(false),
    });
    this.resetPasswordForm = new FormGroup({
      new_password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    });
    this.loadUser();
  }

  loadUser() {
    this.rest.showSpinner();
    this.rest.getAdminUser(this.userId).subscribe({
      next: (res: any) => {
        this.rest.hideSpinner();
        this.user = res?.user;
        this.editForm.patchValue({
          name: this.user.name,
          email: this.user.email,
          username: this.user.username,
          is_admin: this.user.is_admin,
        });
      },
      error: () => {
        this.rest.hideSpinner();
        this.rest.errorToaster('toast.user_load_failed');
      },
    });
  }

  saveEdit() {
    if (this.editForm.invalid) return;
    this.rest.showSpinner();
    this.rest.editAdminUser(this.userId, this.editForm.value).subscribe({
      next: (res: any) => {
        this.rest.hideSpinner();
        this.rest.successToast('toast.user_updated');
        this.user = res?.user;
      },
      error: (err: any) => {
        this.rest.hideSpinner();
        this.rest.errorToaster(err?.error?.message || 'toast.user_update_failed');
      },
    });
  }

  resetPassword() {
    if (this.resetPasswordForm.invalid) return;
    this.rest.showSpinner();
    this.rest
      .resetAdminUserPassword(this.userId, this.resetPasswordForm.value.new_password)
      .subscribe({
        next: () => {
          this.rest.hideSpinner();
          this.rest.successToast('toast.password_reset');
          this.resetPasswordForm.reset();
        },
        error: (err: any) => {
          this.rest.hideSpinner();
          this.rest.errorToaster(err?.error?.message || 'toast.password_reset_failed');
        },
      });
  }

  confirmDelete() {
    this.showDeleteConfirm = true;
  }

  cancelDelete() {
    this.showDeleteConfirm = false;
  }

  deleteUser() {
    this.rest.showSpinner();
    this.rest.deleteAdminUser(this.userId).subscribe({
      next: () => {
        this.rest.hideSpinner();
        this.rest.successToast('toast.user_deleted');
        this.router.navigate(['main/all_users']);
      },
      error: (err: any) => {
        this.rest.hideSpinner();
        this.rest.errorToaster(err?.error?.message || 'toast.user_delete_failed');
        this.showDeleteConfirm = false;
      },
    });
  }

  goBack() {
    this.router.navigate(['main/all_users']);
  }
}
